export async function validateProcessECO(eco) {
    if (eco.conclusiones == '') {
        return false;
    }
    else {
        return true;
    } 
}

export async function validateProcessEstres(estres) {
    if (estres.conclusiones == '') {
        return false;
    }
    else {
        return true;
    }
}

export async function validateProcessPrueba(prueba) {
    if (prueba.conclusiones == '') {
        return false;
    }
    else {
        return true;
    }
}

export async function validateProcessEKG(ekg) {
    if(ekg.hasOwnProperty('conclusions')){
        if (ekg.conclusions == '') {
            return false;
        }
        else {
            return true;
        }
    }else if(ekg.hasOwnProperty('conclusion')){
        if (ekg.conclusion == '') {
            return false;
        }
        else {
            return true;
        }
    }
}

export async function validateProcessHolter(holter) {
    if (holter.conclusion == '' ) {
        return false;
    }
    else {
        return true;
    }
}

export async function validateProcessMapa(mapa) {
    if (mapa.conclusion == '' ) {
        return false;
    }
    else {
        return true;
    }

}

export async function validateProcessTest(test) {
    if (test.conclusiones == '' ) {
        return false;
    }
    else {
        return true;
    }

}

export async function validateFromHCProcessECO(eco) {
    if (eco.conclusions == '') {
        return false;
    }
    else {
        return true;
    }
}

export async function validateFromHCProcessEKG(ekg) {
    if (ekg.conclusions == '') {
        return false;
    }
    else {
        return true;
    }
}

export async function validateFromHCProcessHolter(holter) {
    if (holter.conclusion == '') {
        return false;
    }
    else {
        return true;
    }
}

export async function validateFromHCProcessMap(map) {
    if (map.conclusion == '') {
        return false;
    }
    else {
        return true;
    }
}

export async function validateFromHCProcessStress(stress) {
    if (stress.conclusions == '') {
        return false;
    }
    else {
        return true;
    }
}

export async function validateFromHCProcessTest(test) {
    if (test.conclusions == '') {
        return false;
    }
    else {
        return true;
    }
}